<template>
  <div>
    <div :class="!end?waiting?'typedText':'typedText2':'typedText1'" v-html='typedText'></div>
  </div>
</template>

<script>
// let scrollRef = ref(null);
export default {
  name: "typed",
  props: {
    typedList: {
      type: Array,
      default: [],
    },
    loop: {
      type: Boolean,
      default: false,
    },
    speed: {
      type: Number,
      default: 20,
    },
    onEnd: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      typedText: "",//输出文本
      isEnd:false,//结束标识
      tList:[],//输入文本
      pauseTime:0,//中间停顿
      waiting:false,//等待消息状态
      end:false,
      timer:'',
    };
  },
  mounted() {
    this.tList = this.typedList;
    this.start();
  },

  

  methods: {
    getText(){
      return this.typedText;
    },
    restart(val){
      // if (this.isEnd){
        this.waiting = true;
        this.end = false;
        this.isEnd = false;
        this.typedText = "";
        this.tList = val;
        this.start();
      // }
    },
    start() {
      // const cursor = '<span></span>';
      let j = 0;
      let k = 0;
      this.typedText = "";
      let isPause = false;
      if (this.tList.length <= 0) {
        console.error("typedList数据缺失");
        return;
      }
      
      //<p s >
      let stext='';
      let sindex = -1;
      let arr = this.tList[k].split("");
      console.log("ssff")
      console.log(this.tList[k])
      this.timer = setInterval(() => {
        if (j < arr.length) {
          if(arr[j]=='<'&&arr[j+1]=='h'){
            sindex = j;
            while(arr[j]!='>'&&j < arr.length){
              stext+= arr[j++];
              // j++;
              // j++;j++;
            }
            //j++;
            stext+= arr[j++];
            this.typedText+='<br>'
            console.log("ss:"+ this.typedText)

          }else if(arr[j]=='<'&&arr[j+1]=='/'&&arr[j+2]=='h'&&arr[j+4]=='>'){
            this.typedText += arr[j++];
            this.typedText += arr[j++];
            this.typedText += arr[j++];
            this.typedText += arr[j++];
            this.typedText += arr[j++];
            //str.substring(0, 5) + "-" + str.substring(5);
            if(sindex!=-1){
              this.typedText= this.typedText.substring(sindex, 0) + stext + this.typedText.substring(sindex+4);
              console.log("dd:" + this.typedText)
              sindex = -1;
            }
       
          }
          else 
          if(arr[j]=='<'&&arr[j+1]=='p'){
            while(arr[j]!='>'&&j < arr.length){
              j++
            }
            j++;
          }else if(arr[j]=='<'&&arr[j+1]=='/'&&arr[j+2]=='p'&&arr[j+3]=='>'){
            this.typedText += arr[j++];
            this.typedText += arr[j++];
            this.typedText += arr[j++];
            this.typedText += arr[j++];
          }else if(arr[j]=='<'){
            while(arr[j]!='>'&&j < arr.length){
              this.typedText += arr[j++];
            }
            this.typedText += arr[j++];
          }else{
            // let k = Math.floor((Math.random()*10)+1)
            // if(arr[j]>'Z'|| arr[j]<'a'){
            //   while (k>0&&j < arr.length) {
            //     if(arr[j]>'Z'|| arr[j]<'a'){
            //       break;
            //     }
            //     this.typedText += arr[j++];
            //     k--;
            //   }
            // }else{
            //   this.typedText += arr[j++];
            // }
            this.typedText += arr[j++];
            //this.typedText += arr[j++];
          }
        } else {
          if (k < this.tList.length- 1) {
              if(!isPause){
                isPause = true;
                let timer1 = setTimeout(() => {
                  k++;
                  j = 0;
                  //this.typedText = "";
                  // console.log("---33---")
                  // console.log(this.tList[k])
                  // console.log(this.tList)
                  arr = this.tList[k].split("");
                  isPause = false;
                  this.waiting = false;
                  this.pauseTime = 0;
                }, this.pauseTime);
              }
             //this.speed = 200;
         
          } else {
            // clearInterval(timer);
            // this.isEnd= true;
            // this.onEnd();
            // console.log(this.tList.length)
            // console.log(k)

            if(k < this.tList.length - 1){
                k++;
                j = 0;
                arr = this.tList[k].split("");
            }else if(this.isEnd){
              clearInterval(this.timer);
                //this.isEnd= true;
                this.onEnd();
                this.end = this.isEnd
            }else{
              this.waiting = true;
            }

            // if(this.isEnd){
            //    clearInterval(timer);
            //     //this.isEnd= true;
            //   this.onEnd();
            // }else{
            //   if(k < this.typedList.length - 1){
            //     k++;
            //     j = 0;
            //     arr = this.typedList[k].split("");
            //   }
            // }
            if (this.loop) {
              console.log("sky log : 运行了");
              this.start();
            }
          }
        }
      }, this.speed);
    },
    addMsg(msg){
      //console.log("addMsg")
      this.tList.push(msg)
      this.pauseTime = 0;
      // console.log('内容增加时', this.$refs.scrollRef.value.scrollHeight);
      // this.$refs.scrollRef.value.scrollTop = this.$refs.scrollRef.value.scrollHeight;
    },
    setEnd(end){
      this.isEnd = end;
    },
    close(){
      clearInterval(this.timer);
    }
  },
};
</script>
<style scoped lang="scss" >

/** 光标样式 **/
.typedText.cursor {
  display: inline-block;
  width: 2px;
  height: 20px;
  animation: blink1 1.2s step-end infinite;
  margin-left: 5px;
  vertical-align: sub;
  overflow: scroll;
  // background: url('../ai/avatar.png') no-repeat;
}
@keyframes blink1 {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.typedText2::after {
  content:"｜";//"▂";
  animation: blink 1s infinite;
  font-size: 14px;
  overflow: scroll;
}
.typedText1::after {
  content:"";
}
.typedText::after {
  content: "☞";
  font-size: 16px;
  //content:"▌";
  //color:rgb(5, 5, 5);
  margin-left: 5px;
  //margin-top: -5px;
  // position: absolute;
  //           display: block;
  //           top: .1rem;
  //           right: 0;
  //           width: .16rem;x
  //           height: .16rem;
          
  //           background-size: .16rem, .1rem;
  //           background-position: right;
 // background:url('../../../../assets/logo.png') no-repeat bottom right;
  //animation: blink 1s infinite;
  animation: text 2s infinite;
}

@keyframes text {
  0% {
    color: #dc0e6e;
  }
  35% {
    color: #fff;
  }
  70% {
    color: #30a679;
  }
  100% {
    color: #fff;
  }
}

@keyframes blink {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
